var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#E7E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 20.9908H12.2761L18.4853 14.7817L17.5425 13.8388L11.3333 20.048V20.9908ZM22 22.3241H10V19.4957L18.9567 10.539C19.2171 10.2787 19.6391 10.2787 19.8995 10.539L21.7851 12.4246C22.0455 12.685 22.0455 13.1071 21.7851 13.3674L14.1618 20.9908H22V22.3241ZM18.4853 12.896L19.4281 13.8388L20.3709 12.896L19.4281 11.9532L18.4853 12.896Z",
    fill: "#3D3E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconedit);
export default __webpack_public_path__ + "static/media/icon.edit.81ee98309549272dfe863f100ae15dd5.svg";
export { ForwardRef as ReactComponent };